{
	"id": 7505,
	"moduleNumber": 5,
	"slug": "module-5",
	"kgNodeId": "module-5",
	"title": "The Professional Educator and the Community",
	"subtitle": "Model professional values by protecting confidentiality, using resources responsibly, and maintaining public trust.",
	"type": "lesson",
	"moduleKind": "standard",
	"moduleKindLabel": "Lesson",
	"sourceStatus": "module_list_only",
	"summary": "Module 5 is reserved for community-facing educator ethics, including family relationships, community expectations, assessment integrity, and responsible professional conduct outside the classroom.",
	"estimatedDurationMinutes": 35,
	"activityCount": 2,
	"knowledgeCheck": {
		"included": true,
		"questionCount": 5
	},
	"learningObjectives": [
		"Identify ethical obligations when educator decisions involve families or community members.",
		"Evaluate professional integrity and public trust concerns in community-facing situations.",
		"Choose actions that protect students while maintaining transparent professional boundaries."
	],
	"flow": [
		"Community-facing ethical scenario.",
		"Perspective review.",
		"Ethical reflection and decision analysis.",
		"Knowledge-check or practice items when source content is added."
	],
	"scenarios": [],
	"ethicalSituations": [],
	"sources": {
		"moduleList": "../../../../.working/Praxis ProEthics/Content/ProEthica Module List/ProEthica 2.0_Complete Module List.docx",
		"primary": null,
		"scorm": null,
		"transcripts": [],
		"videos": []
	}
}
